module.exports = __webpack_public_path__ + "media/images/loading_dots-a9701f9bc6d8bff0c2f9daea81f19d72.gif";